import MemberLocationForm from './MemberLocationForm.component';

export default MemberLocationForm;
